import { render } from "./AddSeatRow.vue?vue&type=template&id=45205a4b&scoped=true"
import script from "./AddSeatRow.vue?vue&type=script&lang=js"
export * from "./AddSeatRow.vue?vue&type=script&lang=js"

import "./AddSeatRow.vue?vue&type=style&index=0&id=45205a4b&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45205a4b"]])

export default __exports__